import { POST_GLOBAL_MESSAGE } from "@/store/modules/global/action-types";
import { map, get } from "lodash";
import { HTTP_UNAUTHORIZED_MESSAGE } from "@/utils/requestUtils";
import store from "@/store";

export const addSuccessMessage = (title = null, body = null) => {
  let meta = null;
  if (title || body) {
    meta = {
      title: title,
      body: body
    };
  }
  addGlobalMessage(store.dispatch, { type: "success", meta });
};

export const addGlobalMessage = (dispatch, { type, meta, timeout = 5000 }) => {
  if (!meta) {
    meta = { title: type === "error" ? "Action failed" : "Action successful" };
    console.warn("No human readable message returned from backend");
  } else if (meta.title === HTTP_UNAUTHORIZED_MESSAGE) {
    return;
  }

  let message = {
    snackbar: true,
    type,
    title: meta.title,
    message: meta.body ? meta.body : meta.detail,
    timeout
  };
  dispatch(POST_GLOBAL_MESSAGE, message, { root: true });
};

export const handleWithErrorMessage = async ({
  request,
  dispatch,
  setLoadingFunction = () => {},
  setDataFunction = () => {}
}) => {
  try {
    setLoadingFunction(true);
    const response = await request();
    setDataFunction(response);
    return response;
  } catch (e) {
    errorHandler(dispatch, e);
  } finally {
    setLoadingFunction(false);
  }
};

export const handleWithMessageAndLoading = async ({
  request,
  dispatch,
  setLoadingFunction,
  setDataFunction,
  timeout = 5000
}) => {
  try {
    setLoadingFunction(true);
    const { data, meta } = await request();
    if (setDataFunction) {
      setDataFunction(data);
    }
    addGlobalMessage(dispatch, { type: "success", meta });
    return { data, meta };
  } catch (e) {
    errorHandler(dispatch, e, timeout);
  } finally {
    setLoadingFunction(false);
  }
};

export const handleWithGlobalMessage = async (request, dispatch) => {
  try {
    const { data, meta } = await request();
    addGlobalMessage(dispatch, { type: "success", meta });
    return { data, meta };
  } catch (e) {
    errorHandler(dispatch, e);
  }
};

// Disable pluralize is needed when devour library automatically pluralizes words.
// So making call /bookings/1/accept is transformed into /bookings/1/acceptS
// These two functions prevent that behaviour
export const disablePluralizeForCall = (api, call) => {
  const actualPluralize = api.pluralize;
  api.pluralize = word => word;
  call();
  api.pluralize = actualPluralize;
};

export const disablePluralizeAsync = async (api, call) => {
  const actualPluralize = api.pluralize;
  api.pluralize = word => word;
  api.pluralize.singular = word => word;
  const response = await call();
  api.pluralize = actualPluralize;
  return response;
};

export const errorHandler = (dispatch, exception, timeout = 5000) => {
  const errors =
    get(exception, "errors") || get(exception, "response.data.errors");
  if (errors) {
    map(errors, error => {
      addGlobalMessage(dispatch, {
        type: "error",
        meta: { title: error.title, detail: error.detail || null },
        timeout
      });
    });
  } else {
    addGlobalMessage(dispatch, {
      type: "error",
      meta: { title: "Oops! Something went wrong" },
      timeout
    });
  }
};

export const getToken = () => {
  return localStorage.getItem("token");
};

export const getImpersonateUserId = () => {
  return JSON.parse(localStorage.getItem("impersonateUserId"));
};

export const getSelectedProfile = () => {
  const selectedProfile = localStorage.getItem("selectedProfile");
  return selectedProfile === "undefined" || selectedProfile === null
    ? null
    : JSON.parse(selectedProfile);
};

export const getOriginDomain = () => {
  return window.location.hostname;
};
